export default "__VITE_ASSET__Da$ArI7Q__"